import { apply, call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchPriceChanges(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/ebayPriceChanges/list', {
    query: {
      page: payload.page,
      filters: JSON.stringify(payload.filters),
      sort: payload.filters.sort,
    }
  });
  yield put({
    // $global: true,
    type: 'SET_PRICE_CHANGES',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('FETCH_PRICE_CHANGES', fetchPriceChanges),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/PriceChanges/PriceChanges.sagas.js